import { useQuery } from 'react-query';
import { domainSettingsApi } from '../services/api';
import { DomainSettings } from '../types/domainSettings';

export const DOMAIN_SETTINGS_QUERY_KEY = 'domainSettings';

export const useDomainSettingsQuery = (companyId?: number) =>
  useQuery<DomainSettings>(
    [DOMAIN_SETTINGS_QUERY_KEY, companyId],
    () => domainSettingsApi.getSettings(),
    {
      enabled: !!companyId,
    }
  );
